import { axiosInstance } from '../../../util/axios/instance.axios'

const ONBOARDING_API_PREFIX = '/app/on-boarding/'

export interface TeamTemplateOption {
  label: string
  value: string
}

export interface OnboardingLevelResponse {
  name: string
  levelType: string
  parentLevel: string | null
}

// Backward-compatible alias. Prefer OnboardingLevelResponse in new code.
export type OnBoardingLevelResponse = OnboardingLevelResponse

interface TeamTemplatesResponse {
  templates: TeamTemplateOption[]
}

interface GenerateTeamStructureResponse {
  levels: OnboardingLevelResponse[]
}

/**
 * Fetch team templates for a given industry.
 * @param industry - The selected industry
 * @returns Array of available team templates
 */
export async function getTeamTemplatesByIndustry(industry: string): Promise<TeamTemplateOption[]> {
  const { data } = await axiosInstance.request<TeamTemplatesResponse>({
    url: `${ONBOARDING_API_PREFIX}team-templates`,
    method: 'get',
    params: { industry },
  })

  return data.templates
}

/**
 * Generate team structure from an AI prompt.
 * @param prompt - User input describing the desired team structure
 * @returns Generated team structure levels
 */
export async function getTeamStructureByPrompt(prompt: string): Promise<OnboardingLevelResponse[]> {
  const { data } = await axiosInstance.request<GenerateTeamStructureResponse>({
    url: `${ONBOARDING_API_PREFIX}generate-team-structure`,
    method: 'post',
    data: { prompt },
  })

  return data.levels ?? []
}
